import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
    IProcess,
    IProcessBulkUpdateOperationResponse,
    ODataResponse,
} from '@models';
import { ODataQueryOptions } from '@services/generics/odata.query';
import { ODataService } from '@services/generics/odata.service';
import { MapperService } from '@services/mapper.service';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable()
export class ProcessService extends ODataService<IProcess, number> {
    protected _endpoint = 'odata/Releases';
    constructor(http: HttpClient) {
        super(http, MapperService.processMap);
    }

    public updateReleaseToSpecificVersion(processId: number, packageVersion: string): Observable<ODataResponse<any>> {
        const payload = JSON.stringify({
            packageVersion,
        });

        return this._http.post<any>(
            `${this._endpoint}(${processId
            })/UiPath.Server.Configuration.OData.UpdateToSpecificPackageVersion`,
            payload,
        );
    }

    public updateReleaseToLatestVersion(processId: number): Observable<ODataResponse<any>> {
        return this._http.post<any>(
            `${this._endpoint}(${
            processId})/UiPath.Server.Configuration.OData.UpdateToLatestPackageVersion`,
            null,
        );
    }

    public updateReleasesToLatestVersionBulk(processIds: number[]) {
        return this._http.post<IProcessBulkUpdateOperationResponse>(
            `${this._endpoint}/UiPath.Server.Configuration.OData.UpdateToLatestPackageVersionBulk`,
            { releaseIds: processIds },
        );
    }

    public rollbackReleaseToPreviousVersion(processIds: number): Observable<ODataResponse<any>> {
        return this._http.post<any>(
            `${this._endpoint}(${
            processIds})/UiPath.Server.Configuration.OData.RollbackToPreviousReleaseVersion`,
            null,
        );
    }

    public suggest = (searchTerm: string = '', fetchSize = 20, skip: number) => {
        const queryOptions: ODataQueryOptions = {
            select: ['Id', 'EnvironmentId', 'Name', 'Key', 'Arguments', 'InputArguments'],
            orderBy: ['Name'],
            top: fetchSize,
            skip,
            filter: {
                Name: {
                    contains: searchTerm,
                },
            },
        };

        return this.get(queryOptions)
            .pipe(
                map(
                    ({ data, total }) =>
                        ({
                            total,
                            data: data.map(process => ({
                                id: process.id,
                                text: process.name,
                                data: process,
                            })),
                        }),
                ),
            );
    }

    public suggestName = (searchTerm: string = '', fetchSize = 20, skip: number) => {
        return this.suggest(searchTerm, fetchSize, skip)
            .pipe(
                map(
                    ({ data, total }) =>
                        ({
                            total,
                            data: data.map(process => ({
                                id: process.text,
                                text: process.text,
                            })),
                        }),
                ),
            );
    }
}
